import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEntries = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16 16",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.5 0.5)",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M14.5,1.1c0-0.3-0.3-0.6-0.6-0.6H5.4C5,0.5,4.8,0.8,4.8,1.1v8.5c0,0.3,0.3,0.6,0.6,0.6 c0,0,0,0,0,0h8.5c0.3,0,0.6-0.3,0.6-0.6c0,0,0,0,0,0V1.1z",
			fill: "none",
			stroke: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.3,4.8H1.1C0.8,4.8,0.5,5,0.5,5.4c0,0,0,0,0,0v8.5c0,0.3,0.3,0.6,0.6,0.6c0,0,0,0,0,0h8.5 c0.3,0,0.6-0.3,0.6-0.6c0,0,0,0,0,0v-1.2",
			fill: "none",
			stroke: "currentColor"
		})] }) })
	})
});
export { SvgIconEntries as ReactComponent };
